<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择客户"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :disabled="disabled"
      :clearable="clearable"
      :isInput="isInput"
      :querySearchAsync="querySearchAsync"
      :onSelect="onSelect"
      :placeholder="isInput ? '请输入客户名称' : placeholder"
      valueKey="companyName"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{ scope.row[scope.column.property] / 100 }}</span>
        </section>
        <section v-else>{{ scope.row[scope.column.property] }}</section>
      </section>
      <span slot="isInputTip">
        <slot name="isInputTip" />
      </span>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  customerArchivesList,
} from 'api/archives';
import {
  queryIntelligentMatchCustomer,
  getCustorm,
} from 'api/operate';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  data () {
    return {
      showName: 'customerName',
      tableSelectTar: 'customerId',
      defaultSearchData: {},
      searchBoxDataTmpl: {
        form: [
          { // 客户全称
            label: '客户全称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户全称',
          },
          { // 客户地址
            label: '客户地址',
            value: 'address',
            type: 'input',
            placeholder: '请输入客户地址',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerName',
          label: '客户全称',
        },
        {
          prop: 'address',
          label: '客户地址',
        },
      ],
      tableTitle: [
        {
          prop: 'customerName',
          label: '客户全称',
        },
        {
          prop: 'address',
          label: '客户地址',
        },
      ],
    };
  },
  methods: {
    getListApi: customerArchivesList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    querySearchAsync (queryString, cb) {
      let resInfo = [];
      if (queryString && queryString.length) {
        getCustorm({
          companyName: queryString,
          count: 50,
          type: 0,
        }).then((res) => {
          if (res && res.items) {
            resInfo = res.items;
          }
          cb(resInfo);
        });
      } else {
        // 当没有输入的时候
        resInfo = this.defaultSearchData.items;
        cb(resInfo);
      }
    },
    async onSelect (item) {
      if (item) {
        // this.$refs.chooseTmpl.chooseSelectItem(item);
        const res = await customerArchivesList({
          ...this.otherSearchData,
          customerName: item.customerName,
        });
        if (res && res.items && res.items.length) {
          this.$emit('change', {
            ...res.items[0],
            ...item,
          });
        }
      }
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
  async mounted () {
    this.defaultSearchData = await queryIntelligentMatchCustomer({ searchType: 1 });
  },
};
</script>

<style>
</style>
